interface Props {
  onBack: () => void;
}

const EFFECTIVE = 'August 28, 2026';

export function TermsPage({ onBack }: Props) {
  return (
    <article className="legal">
      <button className="btn btn--ghost legal__back" onClick={onBack}>
        ← Back to leaderboard
      </button>
      <h1>Terms of Service</h1>
      <p className="legal__eff">Effective date: {EFFECTIVE}</p>

      <h2>1. What School Rank is</h2>
      <p>
        School Rank is a <strong>novelty entertainment leaderboard</strong> operated by
        <strong> Eason Books LLC</strong> (“we,” “us”). Visitors
        contribute money to raise a school’s position on public leaderboards. It is a
        for-fun fan product. It is <strong>not affiliated with, sponsored by, or
        endorsed by</strong> any college, university, athletic conference, the NCAA, or
        any other institution. School names and conference groupings are used
        nominatively to identify schools; no institutional trademark, logo, or mascot
        is used.
      </p>

      <h2>2. Contributions are not purchases of goods</h2>
      <p>
        A “contribution” buys <strong>leaderboard points only</strong> — a position on a
        for-entertainment ranking. It confers no product, service, ownership, equity,
        voting right, or benefit of any kind, and no relationship with any named school.
        Points have no cash value and cannot be redeemed, transferred, or exchanged.
      </p>

      <h2>3. All contributions are final and non-refundable</h2>
      <p>
        Because a contribution instantly and permanently affects the public
        leaderboard, <strong>all contributions are final and non-refundable</strong>,
        except where a refund is required by applicable law. By contributing you
        acknowledge you are paying for a novelty leaderboard position and not for any
        good or service.
      </p>

      <h2>4. Payments</h2>
      <p>
        Payments are processed by <strong>Stripe</strong>. We do not receive or store
        your full card details. Your use of the payment flow is also subject to
        Stripe’s terms. You represent that you are authorized to use the payment method
        and are at least 18 years old (or the age of majority in your jurisdiction).
      </p>

      <h2>5. Acceptable use</h2>
      <p>
        Do not use School Rank for unlawful purposes, to launder funds, to defame, or to
        misrepresent your relationship to any institution. We may remove listings,
        reverse manipulative activity, or refuse service at our discretion.
      </p>

      <h2>6. No warranty; limitation of liability</h2>
      <p>
        The service is provided “as is,” without warranties of any kind. To the maximum
        extent permitted by law, our aggregate liability arising from your use of the
        service is limited to the amount you contributed in the 30 days preceding the
        claim.
      </p>

      <h2>7. Changes</h2>
      <p>
        We may update these Terms. Continued use after an update constitutes acceptance
        of the revised Terms.
      </p>

      <h2>8. Contact</h2>
      <p>Questions about these Terms: admin@easonbooks.com</p>

      <p className="legal__copy">© 2026 Eason Books LLC. All rights reserved. School Rank is operated by Eason Books LLC.</p>
    </article>
  );
}
